import { Component, OnInit, Input, HostBinding } from "@angular/core";

@Component({
    selector: "ig-frame-indicator",
    template: ``,
    styleUrls: ["./frame-indicator.component.scss"],
})
export class FrameIndicatorComponent implements OnInit {
    @Input()
    public isEnabled = false;

    @Input()
    public frameHeight: number;

    @HostBinding("style.display")
    get styleDisplay() {
        return this.isEnabled ? "block" : "none";
    }

    @HostBinding("style.height.px")
    get styleHeightInPx() {
        return this.frameHeight;
    }

    constructor() {}

    ngOnInit() {}
}
